<div class="assignments-scroller">
  <div class="asn-card" *ngFor="let assignment of jobAssignments; let i = index">
    <div class="asn-top">
      <span class="asn-icon"><i class="bi bi-briefcase-fill"></i></span>
      <div class="asn-titles">
        <div class="job">{{ assignment.job }}</div>
        <div class="client">{{ assignment.client }}</div>
      </div>
      <span class="asn-status">Active</span>
    </div>

    <div class="asn-meta-row">
      <div class="asn-meta">
        <span class="lbl">Start</span>
        <span class="val">
          <i class="bi bi-calendar3"></i>{{ dataSharedService.tranformDate(assignment.start_date) }}
        </span>
      </div>
      <div class="asn-meta">
        <span class="lbl">End</span>
        <span class="val">
          <i class="bi bi-calendar-check"></i>{{ dataSharedService.tranformDate(assignment.end_date) }}
        </span>
      </div>
    </div>

    <div class="asn-actions">
      <!-- <button type="button" class="btn btn-secondary asn-view"
        title="View details"
        (click)="viewAssignment(assignment)">
        <i class="bi bi-eye"></i>
      </button> -->
      <button type="button" class="btn btn-primary asn-log" (click)="createTimesheet(assignment)">
        <i class="bi bi-plus-lg"></i>Add timesheet
      </button>
    </div>
  </div>
</div>